export const DrawerHeaderStyle = {
  backgroundColor: "#586370",
  padding: "1rem",
  color: "white",
};

export const ModalButtonStyle = {
  color: "#586370",
  border: "1px solid #586370",
  borderRadius: "8px",
};
